// extracted by mini-css-extract-plugin
export default {"title":"LY6c5z"};